import {Injectable} from "@angular/core";
import {
    QueryStringSerializationService
} from "../../shared-library/services/environment/query-string-serialization.service";
import {SavedSearchesParametersModel} from "../models/saved-searches-parameters.model";
import {isNumeric} from "rxjs/internal-compatibility";

@Injectable({
    providedIn: "root"
})
export class SavedSearchesParametersFactoryService {
    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }
    public createFromQueryString(queryString: string): SavedSearchesParametersModel {
        const rawValues = this._serializationService.deserialize<SavedSearchesParametersModel>(queryString);
        const parsedValues = new SavedSearchesParametersModel();

        parsedValues.sortOption = rawValues.sortOption || "0";
        parsedValues.pageNumber = (rawValues.pageNumber > 0) ? Number(rawValues.pageNumber) : 1;
        parsedValues.pageSize = ((rawValues.pageSize > 0) && (rawValues.pageSize <= 100)) ? Number(rawValues.pageSize) : 12;
        if (!isNumeric(parsedValues.sortOption)) {
            parsedValues.sortOption = "0";
        }
        return parsedValues;
    }

    public serialiseToQueryString(searchParams: SavedSearchesParametersModel): string {
        return this._serializationService.serialize(searchParams);
    }
}
